module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-combined-1-ipad.f499dd88.png";